/**
 * Photos are part of version history: a version shows the photographs pages (and cover photos) as
 * they were, and "Photos" in the list of what changed. Mirrors MagicReportManifest.IncludePhotos on
 * the backend; versions recorded before photos were versioned show the current photos.
 */
export const VERSION_PHOTOS = true;

/**
 * Version history on/off; mirrors MagicReportVersioning__Enabled on the backend, which answers 404
 * on the history endpoints while it is off. When false, the "Version history" link, the history
 * view and the revision/checkpoint calls are skipped. The stale-save check (X-Report-Version)
 * still runs either way. On unless REACT_APP_MAGIC_REPORT_VERSIONING_ENABLED is 'false'.
 */
export const VERSION_HISTORY_ENABLED = process.env.REACT_APP_MAGIC_REPORT_VERSIONING_ENABLED !== 'false';
